import React from 'react'
import { CrossClientNeedsActionElement } from './CrossClientNeedsActionElement'
import { type CrossClientNeedsActionGroups } from './useCrossClientNeedsActionGroups'
import { CrossClientRowSkeleton } from '../CrossClientRowSkeleton'
import { CrossClientEmptyState } from '../CrossClientEmptyState'
import { ReactComponent as MatchIcon } from '../../../../assets/images/ccq/group-matched.svg'
import { Button } from '../../../../components/Button/Button'

interface CrossClientNeedsActionProps {
  groups: CrossClientNeedsActionGroups
}

export const CrossClientNeedsAction: React.FC<CrossClientNeedsActionProps> = ({ groups }) => {
  const {
    matchesWaiting,
    matchesWaitingHasMore,
    matchesWaitingLoadingMore,
    showMoreMatchesWaiting,
    continueToFind,
    continueToFindHasMore,
    continueToFindLoadingMore,
    showMoreContinueToFind,
    loading,
  } = groups

  if (loading) {
    return <CrossClientRowSkeleton count={3} />
  }

  if (!matchesWaiting.length && !continueToFind.length) {
    return <CrossClientEmptyState message='No queries waiting for action' />
  }

  return (
    <div className='d-flex flex-column gap-2 w-100'>
      {matchesWaiting.length ? (
        <>
          <CrossClientNeedsActionDivider icon={<MatchIcon width={12} height={12} />} label='Matches waiting for action' />
          {matchesWaiting.map((execution) => (
            <CrossClientNeedsActionElement key={execution.id} execution={execution} variant='matches' />
          ))}
          {matchesWaitingHasMore ? <CrossClientNeedsActionShowMore loading={matchesWaitingLoadingMore} onClick={showMoreMatchesWaiting} /> : null}
        </>
      ) : null}
      {continueToFind.length ? (
        <>
          <CrossClientNeedsActionDivider icon={<i className='bi bi-play-fill fs-6' />} label='Continue to find more matches' />
          {continueToFind.map((execution) => (
            <CrossClientNeedsActionElement key={execution.id} execution={execution} variant='continue' />
          ))}
          {continueToFindHasMore ? <CrossClientNeedsActionShowMore loading={continueToFindLoadingMore} onClick={showMoreContinueToFind} /> : null}
        </>
      ) : null}
    </div>
  )
}

const CrossClientNeedsActionShowMore: React.FC<{ loading: boolean; onClick: () => void }> = ({ loading, onClick }) => (
  <Button variant='header' className='button-small zocks-border-0.5 align-self-center' loading={loading} onClick={onClick}>
    Show more…
  </Button>
)

const CrossClientNeedsActionDivider: React.FC<{ icon: React.ReactNode; label: string }> = ({ icon, label }) => (
  <div className='d-flex gap-2 align-items-center w-100 cross-client-tabs-divider'>
    <div className='flex-grow-1 cross-client-tabs-divider-line' />
    <div className='d-flex gap-1 align-items-center paragraph-small zocks-text-gray-700'>
      {icon}
      <span>{label}</span>
    </div>
    <div className='flex-grow-1 cross-client-tabs-divider-line' />
  </div>
)
